import { defineStore } from 'pinia'
import httpClient from '@/api/httpClient'
import { useMessagesStore } from '@/stores/messages'

const getDefaultSqueue = () => ({
  id: null,
  title: '',
  slug: '',
  system_record: false,
  enabled: true,
  list_order: 0,
  color: null
})

export const useSqueueStore = defineStore('squeue', {
  state: () => ({
    squeue: getDefaultSqueue()
  }),

  actions: {
    async fetch({ squeueId }) {
      return httpClient.get(`/api/internal/squeues/${squeueId}`)
        .then(({ data: { squeue } }) => {
          this.squeue = squeue
        })
        .catch(err => {
          console.error(err)
          useMessagesStore().addError(err)
        })
    },

    async save() {
      return await this.squeue.id ? this.update() : this.create()
    },

    async create() {
      const { squeue } = this

      return httpClient.post('/api/internal/squeues/', { squeue })
        .then(({ data: { squeue } }) => {
          this.squeue = squeue
          useMessagesStore().addNotice('Section status created')
        })
        .catch(err => {
          console.error(err)
          useMessagesStore().addError(err)
          throw err
        })
    },

    async update() {
      const { squeue } = this

      return httpClient.patch(`/api/internal/squeues/${squeue.id}`, { squeue })
        .then(({ data: { squeue } }) => {
          this.squeue = squeue
          useMessagesStore().addNotice('Section status saved')
        })
        .catch(err => {
          console.error(err)
          useMessagesStore().addError(err)
          throw err
        })
    },

    async destroy() {
      const { id } = this.squeue

      return httpClient.delete(`/api/internal/squeues/${id}`)
        .then(() => {
          this.reset()
          useMessagesStore().addNotice('Section status deleted')
        })
        .catch(err => {
          console.error(err)
          useMessagesStore().addError(err)
        })
    }
  }
})
